import { SpecificationDetailDto, SpecificationEditDto } from './specification';

export const mapSpecificationDetailToEdit = (
  dto: SpecificationDetailDto
): SpecificationEditDto => ({
  id: dto.id,
  no: dto.no,
  name: dto.name,
  active: dto.active,
  regDate: dto.regDate,
  reference: dto.reference,
  specialMarking: dto.specialMarking,
  labelTemplateText: dto.labelTemplateText,
  description: dto.description,
  lockWaybill: dto.lockWaybill,
  revision: dto.revision,
  revisionDate: dto.revisionDate,
  internalRevision: dto.internalRevision,
  internalRevisionDate: dto.internalRevisionDate,
  plantId: dto.plantId,
  productTypeId: dto.productTypeId,
  segmentId: dto.segmentId,
  gradeId: dto.gradeId,
  customerId: dto.customerId,
  packagingId: dto.packagingId,
  palletId: dto.palletId,
  labelTemplateId: dto.labelTemplateId,
  mixtureTypeId: dto.mixtureTypeId
});
